<template>
  <div
    class="container-fluid promotion-page p-2 pt-3"
    style="scrollbar-width: none; -ms-overflow-style: none; height: 100vh; overflow-y: scroll; background-size: cover; padding-bottom: 15rem; background-attachment: fixed;"
  >
    <div class="pb-5">
      <h2 class="text-center text-dark mb-3">
        {{ label('Promotion', 'ပရိုမိုးရှင်း') }}
      </h2>

      <div class="d-flex flex-wrap px-1 mb-3">
        <button
          v-for="category in categories"
          :key="category.id"
          type="button"
          class="detail-button w-auto text-nowrap mx-1 my-1"
          :class="{ active: activeCategory === category.id }"
          @click="activeCategory = category.id"
        >
          {{ category.id === 'all' ? label('All', 'အားလုံး') : category.name }}
        </button>
      </div>

      <div
        v-if="loading"
        class="text-center text-muted py-5"
      >
        {{ label('Loading...', 'ဆောင်ရွက်နေသည်...') }}
      </div>

      <div
        v-else-if="promotions.length === 0"
        class="text-center text-muted py-5"
      >
        <p class="mb-1">{{ label('No promotions yet', 'ပရိုမိုးရှင်း မရှိသေးပါ') }}</p>
        <p class="mb-0 small">{{ label('Please check again later.', 'နောက်တစ်ကြိမ် ပြန်လည်စစ်ဆေးပါ။') }}</p>
      </div>

      <div
        v-else
        class="col-12 px-1 mb-5 pb-5"
      >
        <div
          v-for="promotion in promotions"
          :key="promotion.id"
          class="card bg-transparent mt-2"
          style="box-shadow: none;"
        >
          <router-link :to="`/promotion/${promotion.id}`">
            <img
              v-if="promotion.image"
              :src="promotion.image"
              style="border-radius: 5px; width: 100%;"
              :alt="promotion.name"
            >
          </router-link>
          <div class="px-3 py-2 d-flex justify-content-between align-items-center bg-transparent">
            <div class="pr-2">
              <h3 class="text-dark my-auto">{{ promotion.name }}</h3>
              <small
                v-if="promotion.claim_once_per_user && promotion.claimed"
                class="text-warning"
              >
                {{ label('You have already claimed this promotion.', 'ဤပရိုမိုးရှင်းကို ရယူပြီးသားဖြစ်ပါသည်။') }}
              </small>
              <small
                v-else-if="claimableAmount(promotion)"
                class="text-muted d-block"
              >
                {{ label('Minimum deposit', 'အနည်းဆုံး ငွေသွင်း') }}
                {{ claimableAmount(promotion).toLocaleString() }}
              </small>
            </div>
            <router-link
              class="detail-button col-3"
              :to="`/promotion/${promotion.id}`"
            >
              {{ label('Detail', 'အသေးစိတ်') }}
            </router-link>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      loading: false,
      activeCategory: 'all',
      categories: [{ id: 'all', name: 'all' }],
      promotions: [],
    };
  },
  watch: {
    activeCategory() {
      this.fetchPromotions();
    },
  },
  mounted() {
    this.fetchCategories();
    this.fetchPromotions();
  },
  methods: {
    label(en, mm) {
      return this.$store.state.language === 'en' ? en : mm;
    },
    claimableAmount(promotion) {
      const amount = Number(promotion?.claimable_amount);
      return Number.isFinite(amount) && amount > 0 ? amount : 0;
    },
    async fetchCategories() {
      try {
        const { data } = await axios.get('/promotion-categories?active=1');
        const apiCategories = data.data || [];
        this.categories = [{ id: 'all', name: 'all' }, ...apiCategories];
      } catch (error) {
        console.error(error);
      }
    },
    async fetchPromotions() {
      this.loading = true;
      try {
        let url = '/promotions?active=1';
        if (this.activeCategory !== 'all') {
          url += `&category_id=${this.activeCategory}`;
        }
        const { data } = await axios.get(url);
        const list = data.data ?? data ?? [];
        this.promotions = Array.isArray(list) ? list : [];
      } catch (error) {
        console.error(error);
        this.promotions = [];
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<style scoped>
.promotion-page {
  background: linear-gradient(180deg, #eed1f6 0%, #fdf4fc 22%, #ffffff 55%, #fdf4fc 100%);
}

.detail-button {
  appearance: none;
  background-color: transparent;
  border: 1px solid #714DC7;
  text-transform: uppercase;
  border-radius: 14px;
  box-sizing: border-box;
  color: #714DC7;
  cursor: pointer;
  display: inline-block;
  font-size: 0.9rem;
  font-weight: 450;
  line-height: normal;
  margin: 0;
  outline: none;
  padding: 4px 8px;
  text-align: center;
  text-decoration: none;
  transition: all 300ms cubic-bezier(.23, 1, 0.32, 1);
  user-select: none;
  touch-action: manipulation;
}

.detail-button.active,
.detail-button:hover {
  color: #fff;
  background: linear-gradient(135deg, #f179e2 0%, #DD4DD1 50%, #8a69d9 100%);
  border-color: #714DC7;
}
</style>
